var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.98257 0C3.75947 0 3.5455 0.0848122 3.38774 0.235779C3.22998 0.386746 3.14135 0.591501 3.14135 0.805V21.39H0.84122C0.618114 21.39 0.404147 21.4748 0.246388 21.6258C0.0886285 21.7767 0 21.9815 0 22.195C0 22.4085 0.0886285 22.6133 0.246388 22.7642C0.404147 22.9152 0.618114 23 0.84122 23H6.84993C7.07304 23 7.28701 22.9152 7.44477 22.7642C7.60252 22.6133 7.69115 22.4085 7.69115 22.195C7.69115 21.9815 7.60252 21.7767 7.44477 21.6258C7.28701 21.4748 7.07304 21.39 6.84993 21.39H4.82379V10.81H15.1588C15.3819 10.81 15.5959 10.7252 15.7536 10.5742C15.9114 10.4233 16 10.2185 16 10.005V0.805C16 0.591501 15.9114 0.386746 15.7536 0.235779C15.5959 0.0848122 15.3819 0 15.1588 0H4.10275C4.08238 5.90293e-05 4.06201 0.000826202 4.0417 0.0023C4.02203 0.000870024 4.00231 0.000102882 3.98257 0ZM7.29938 1.61H9.6548V3.3189H12.0102V1.61H14.3176V3.3189H12.0102V5.57267H14.3176V7.82667H12.0102V9.2H9.6548V7.8269H7.29938V9.2H4.94397V7.8269H7.29938V5.57267H4.94397V3.31867H7.29938V1.61ZM7.29938 3.3189V5.57267H9.6548V3.31867H7.29938V3.3189ZM9.6548 5.57267V7.8269L12.0102 7.82667V5.57267H9.6548Z",
    fill: "#133940"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndFlag);
export default __webpack_public_path__ + "static/media/EndFlag.e9206aa7bf045901ada806ed8652d930.svg";
export { ForwardRef as ReactComponent };